import React from 'react';

export function IconFilterList () {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" fill="#565F5C" fillRule="evenodd"/>
    </svg>
  );
}
